import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { KeyboardEvent, MouseEvent, useState } from 'react';

interface IKCFCheckboxProps {
    overrideIconOn: IconDefinition;
    overrideIconOff: IconDefinition;
    overrideIconOnClick: () => void;
    checked: boolean;
}

export function KCFCheckbox(props: IKCFCheckboxProps) {
    const { overrideIconOn, overrideIconOff, overrideIconOnClick, checked } = props;

    const [iconChecked, setIconChecked] = useState(checked);

    const onOverrideClick = (event: MouseEvent | KeyboardEvent) => {
        event.stopPropagation();
        setIconChecked(!iconChecked);
        overrideIconOnClick();
    };

    const handleOverrideCheckbox = () => {
        let icon;
        if (iconChecked) {
            icon = overrideIconOn;
        } else {
            icon = overrideIconOff;
        }

        return <FontAwesomeIcon color="var(--text-link)" icon={icon} />;
    };
    return (
        <div
            className="cursor-pointer"
            role="checkbox"
            aria-checked={iconChecked}
            tabIndex={0}
            onClick={onOverrideClick}
            onKeyPress={onOverrideClick}
        >
            {handleOverrideCheckbox()}
        </div>
    );
}
